export default __webpack_public_path__ + "static/media/karthik.6e45d33d.jpg";